// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversation',
  working: 'En cours…',
  stopped: "Arrêté. Rien n'a changé.",
  step_stopped: 'Arrêté',
  not_sent: 'Non envoyé',
  failed: {
    text: "Un problème est survenu de notre côté, donc rien n'a changé. Réessayez dans un instant.",
    retry: 'Réessayer',
  },
  question: {
    type_answer: 'Ou saisissez votre réponse ci-dessous.',
  },
  unavailable: {
    title: {
      amigo: "Amigo n'est pas disponible pour le moment.",
      assistant: "L'assistant n'est pas disponible pour le moment.",
    },
    text: "Rien n'a changé, et le reste du tableau de bord fonctionne normalement. Réessayez dans quelques minutes.",
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: "Aujourd'hui",
  when: {
    today: "Aujourd'hui, {{time}}",
    yesterday: 'Hier, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Nouvelle discussion pour {{restaurant}}. Les discussions de {{previous}} se trouvent sous Discussions quand vous y retournez.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chat de {{name}} (FoodAmigos)',
      owner: 'Chat de {{name}} (propriétaire)',
      staff: 'Chat de {{name}} (personnel)',
      partner: 'Chat de {{name}} (partenaire)',
      other: 'Chat de {{name}}',
      unnamed: "Chat d'une autre personne",
    },
    text: 'Discussion de {{name}}. Vous pouvez la lire, mais pas y répondre ni approuver ses cartes.',
    text_unnamed: "Chat d'une autre personne. Vous pouvez le lire, mais pas répondre ni approuver ses cartes.",
    new_chat: 'Nouvelle discussion',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Ce chat est terminé. Démarrez un nouveau chat pour continuer.',
    new_chat: 'Nouvelle discussion',
    moved_line: 'Nouveau chat, car le précédent était terminé',
  },
  composer: {
    label: 'Message',
    placeholder: 'Posez une question ou décrivez une modification',
    placeholder_answer: 'Saisissez votre réponse',
    hint: 'Entrée pour envoyer · Maj+Entrée pour une nouvelle ligne',
  },
  table: {
    show_all: 'Afficher les {{count}} lignes',
    show_fewer: 'Afficher moins',
  },
  steps: {
    areas: 'Vérification de ce que je peux faire ici',
    area_describe: 'Analyse de {{area}}',
    read: 'Lecture de vos données',
    propose: 'Préparation de la modification',
    change_set_get: 'Vérification de la modification',
    gap_record: 'Note transmise à notre équipe',
    research: 'Recherche du fonctionnement',
    screen_find: 'Recherche de la bonne page',
    file_read: 'Lecture de votre fichier',
    shop_check: 'Vérification de votre boutique',
    area_describe_other: 'Examen de cette zone',
    other: 'Vérification en cours',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Impossible de lire le menu',
      hours: "Impossible de lire les horaires d'ouverture",
      order_settings: 'Impossible de lire les paramètres de commande',
      my_info: 'Impossible de lire vos informations',
      marketing: 'Impossible de lire votre marketing',
      gift_cards: 'Impossible de lire les cartes cadeaux',
      reports: 'Impossible de lire vos chiffres',
      other: 'Impossible de lire vos données',
    },
    propose: {
      menu: 'Impossible de préparer la modification du menu',
      hours: "Impossible de préparer la modification des horaires d'ouverture",
      order_settings: 'Impossible de préparer la modification des paramètres de commande',
      my_info: 'Impossible de préparer la modification de vos informations',
      marketing: 'Impossible de préparer la modification du marketing',
      gift_cards: 'Impossible de préparer la modification des cartes cadeaux',
      other: 'Impossible de préparer la modification',
    },
    change_set_get: { other: 'Impossible de vérifier la modification' },
    research: { other: 'Impossible de chercher comment cela fonctionne' },
    screen_find: { other: 'Impossible de trouver la page' },
    file_read: { other: 'Impossible de lire votre fichier' },
    shop_check: { other: "Impossible d'ouvrir votre boutique" },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'le menu',
    hours: "les horaires d'ouverture",
    order_settings: 'les paramètres de commande',
    my_info: 'les informations de votre restaurant',
    marketing: 'le marketing',
    reports: 'les rapports',
  },
};
